export const openDialog = (dialogId) => {
  const $dialog = document.getElementById(dialogId);

  if ($dialog) {
    $dialog.classList.add('dialog--open');
  }
};

export const closeDialog = (dialogId) => {
  const $$dialog = dialogId
    ? [document.getElementById(dialogId)].filter(Boolean)
    : document.querySelectorAll('.dialog--open');

  $$dialog.forEach(($dialog) => {
    $dialog.classList.remove('dialog--open');
    $dialog.classList.add('dialog--close');
  });
};

document.querySelectorAll('[data-dialog]').forEach(($element) => {
  $element.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    openDialog(event.currentTarget.dataset.dialog);
  });
});

document.querySelectorAll('.dialog__overlay, .dialog__close').forEach(($element) => {
  $element.addEventListener('click', () => {
    closeDialog();
  });
});

document.querySelectorAll('.dialog__overlay').forEach(($overlay) => {
  $overlay.addEventListener('transitionend', () => {
    document.querySelectorAll('.dialog--close').forEach(($dialog) => {
      $dialog.classList.remove('dialog--close');
    });
  });
});

window.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' || event.key === 'Esc') {
    closeDialog();
  }
});
